// Central advertising and commerce content used by Demo Engine Power Ups.
// Keeping one profile per industry makes all selected Power Ups tell the same
// realistic story instead of independently falling back to generic content.

const profile = ({
  sponsorLevels,
  sponsors,
  vendors,
  participantTicket,
  auctionItems,
  products,
  hashtags,
  passportPeople,
}) => ({
  sponsorLevels,
  sponsors,
  vendors,
  participantTicket,
  auctionItems,
  products,
  hashtags,
  passportPeople,
});

export const POWER_UP_PROFILES = {
  car_show: profile({
    sponsorLevels: ["Title Sponsor", "Gold Sponsor", "Silver Sponsor", "Bronze Sponsor"],
    sponsors: ["Vanabliss", "Performance Tire Center", "Classic Detail Supply", "Route 26 Credit Union"],
    vendors: [
      ["Northwest Parts Exchange", "Automotive Parts"],
      ["Chrome & Coffee", "Food Vendor"],
      ["Detail Pro Supply", "Automotive Supplies"],
      ["Classic Threads", "Event Merchandise"],
    ],
    participantTicket: ["Vehicle Registration", "Show-field registration and admission for one vehicle.", 2500],
    auctionItems: [
      ["Professional Vehicle Photo Session", "Local Motors Media"],
      ["Premium Detail Package", "Detail Pro Supply"],
      ["Performance Parts Gift Card", "Northwest Parts Exchange"],
      ["Collector Garage Sign", "Classic Threads"],
    ],
    products: [
      ["Official Car Show T-Shirt", "Apparel"],
      ["Commemorative Dash Plaque", "Collectibles"],
      ["Show Sticker Pack", "Accessories"],
      ["Limited Edition Show Poster", "Collectibles"],
    ],
    hashtags: ["CarShow", "ClassicCars", "ShowAndShine"],
    passportPeople: ["Monica Reynolds", "Trevor Campbell", "Jasmine Flores"],
  }),
  art_show: profile({
    sponsorLevels: ["Presenting Sponsor", "Gallery Sponsor", "Artist Sponsor", "Community Sponsor"],
    sponsors: ["Downtown Gallery", "Creative Canvas Foundation", "Art Supply Center", "Community Arts Council"],
    vendors: [
      ["Creative Canvas Supply", "Art Supplies"],
      ["Gallery Coffee Cart", "Refreshments"],
      ["Frame & Finish", "Custom Framing"],
      ["Local Maker Market", "Artist Market"],
    ],
    participantTicket: ["Artist Preview Pass", "Early exhibition access for participating artists and guests.", 1800],
    auctionItems: [
      ["Commissioned Portrait Session", "River District Artists"],
      ["Private Gallery Tour", "Downtown Gallery"],
      ["Limited Edition Print Set", "Community Arts Council"],
      ["Professional Framing Package", "Frame & Finish"],
    ],
    products: [
      ["Exhibition Catalog", "Books"],
      ["Artist Series Tote", "Accessories"],
      ["Gallery Poster", "Collectibles"],
      ["Community Arts T-Shirt", "Apparel"],
    ],
    hashtags: ["ArtShow", "LocalArtists", "GalleryOpening"],
    passportPeople: ["Elena Marquez", "Theo Bennett", "Priya Shah"],
  }),
  pet_show: profile({
    sponsorLevels: ["Presenting Sponsor", "Veterinary Sponsor", "Pet Care Sponsor", "Community Sponsor"],
    sponsors: ["Happy Paws Veterinary", "Pet Paradise", "Healthy Pets Clinic", "Local Animal Rescue"],
    vendors: [
      ["Happy Paws Treats", "Pet Supplies"],
      ["Healthy Pets Clinic", "Pet Wellness"],
      ["Rescue Friends Booth", "Adoption Services"],
      ["Bark & Brew Cart", "Refreshments"],
    ],
    participantTicket: ["Pet and Handler Entry", "Show registration for one pet and handler.", 1500],
    auctionItems: [
      ["Custom Pet Portrait", "Paws & Portraits Studio"],
      ["Annual Wellness Package", "Happy Paws Veterinary"],
      ["Premium Treat Basket", "Happy Paws Treats"],
      ["Private Training Session", "Good Neighbor Dog Training"],
    ],
    products: [
      ["Official Show Bandana", "Pet Accessories"],
      ["Paws and Friends T-Shirt", "Apparel"],
      ["Pet Show Sticker Pack", "Accessories"],
      ["Commemorative Pet Tag", "Pet Accessories"],
    ],
    hashtags: ["PetShow", "BestInShow", "PetCommunity"],
    passportPeople: ["Maya Thompson", "Noah Kim", "Olivia Garcia"],
  }),
  school_election: profile({
    sponsorLevels: ["School Partner", "Student Programs Partner", "Activity Sponsor", "Community Supporter"],
    sponsors: ["School Foundation", "Parent Teacher Association", "Community Credit Union", "Alumni Association"],
    vendors: [
      ["Student Store", "School Merchandise"],
      ["PTA Information Booth", "Family Resources"],
      ["Activities Council", "Student Programs"],
      ["Graduation Fundraiser", "Student Fundraiser"],
    ],
    participantTicket: ["Community Election Pass", "Complimentary access to election-night activities.", 0],
    auctionItems: [
      ["School Spirit Basket", "Parent Teacher Association"],
      ["Reserved Graduation Seating", "School Foundation"],
      ["Principal for a Morning", "School Administration"],
      ["Student Art Collection", "Visual Arts Club"],
    ],
    products: [
      ["Student Council T-Shirt", "Apparel"],
      ["School Spirit Hoodie", "Apparel"],
      ["Election Sticker Pack", "Accessories"],
      ["Campus Leadership Notebook", "School Supplies"],
    ],
    hashtags: ["StudentVoice", "SchoolElection", "CampusLeadership"],
    passportPeople: ["Avery Johnson", "Mateo Rivera", "Zoe Patel"],
  }),
  silent_auction: profile({
    sponsorLevels: ["Presenting Partner", "Benefactor", "Supporting Partner", "Community Partner"],
    sponsors: ["Community Giving Foundation", "First Harbor Bank", "Northstar Insurance", "Civic Partners Network"],
    vendors: [
      ["Bidder Concierge", "Guest Services"],
      ["Celebration Catering", "Catering"],
      ["Signature Events", "Event Services"],
      ["Community Donor Gallery", "Donor Showcase"],
    ],
    participantTicket: ["Benefit Gala Admission", "Admission to the auction preview and benefit reception.", 4500],
    auctionItems: [
      ["Wine Country Weekend", "Voyager Travel Group"],
      ["Chef's Table for Eight", "Celebration Catering"],
      ["Courtside Game Experience", "Community Athletics Club"],
      ["Original Regional Artwork", "Community Donor Gallery"],
    ],
    products: [
      ["Benefit Gala Tote", "Accessories"],
      ["Donor Recognition Pin", "Collectibles"],
      ["Auction Event Program", "Books"],
      ["Community Giving T-Shirt", "Apparel"],
    ],
    hashtags: ["SilentAuction", "BidForGood", "CommunityGiving"],
    passportPeople: ["Claire Donovan", "Benjamin Hayes", "Aisha Coleman"],
  }),
  fundraiser: profile({
    sponsorLevels: ["Impact Partner", "Hope Partner", "Community Builder", "Friend of the Cause"],
    sponsors: ["Bright Futures Foundation", "Community First Bank", "Good Neighbor Health", "Local Business Alliance"],
    vendors: [
      ["Impact Story Booth", "Community Outreach"],
      ["Give Local Cafe", "Refreshments"],
      ["Volunteer Welcome Center", "Volunteer Services"],
      ["Community Partner Row", "Partner Showcase"],
    ],
    participantTicket: ["Supporter Reception", "Admission to the supporter reception and impact program.", 3000],
    auctionItems: [
      ["Community Chef Dinner", "Give Local Cafe"],
      ["Weekend Wellness Retreat", "Good Neighbor Health"],
      ["Local Business Gift Collection", "Local Business Alliance"],
      ["Impact Sponsor Experience", "Bright Futures Foundation"],
    ],
    products: [
      ["Together We Give T-Shirt", "Apparel"],
      ["Impact Supporter Tote", "Accessories"],
      ["Community Giving Journal", "Stationery"],
      ["Hope Campaign Pin", "Collectibles"],
    ],
    hashtags: ["Fundraiser", "GiveBack", "CommunityImpact"],
    passportPeople: ["Hannah Scott", "Isaac Murphy", "Mei Lin"],
  }),
  festival: profile({
    sponsorLevels: ["Title Sponsor", "Entertainment Sponsor", "Food Court Sponsor", "Community Sponsor"],
    sponsors: ["City Bank", "Community Power", "Festival Foods", "Local Radio Network"],
    vendors: [
      ["Harvest Street Kitchen", "Food Vendor"],
      ["Main Street Lemonade", "Beverage Vendor"],
      ["Makers Guild Market", "Artisan Market"],
      ["Festival Fun Shop", "Event Merchandise"],
    ],
    participantTicket: ["Weekend Festival Pass", "Admission for all public festival sessions.", 2800],
    auctionItems: [
      ["Backstage Music Experience", "Local Radio Network"],
      ["Festival Food Tour", "Festival Foods"],
      ["Artisan Market Collection", "Makers Guild Market"],
      ["VIP Main Stage Package", "Community Power"],
    ],
    products: [
      ["Official Festival T-Shirt", "Apparel"],
      ["Main Street Festival Tote", "Accessories"],
      ["Collectible Festival Poster", "Collectibles"],
      ["Reusable Festival Cup", "Drinkware"],
    ],
    hashtags: ["CommunityFestival", "MainStreet", "FestivalWeekend"],
    passportPeople: ["Ruby Martinez", "Finn Cooper", "Amara Lewis"],
  }),
  nonprofit: profile({
    sponsorLevels: ["Mission Partner", "Impact Partner", "Program Sponsor", "Community Ally"],
    sponsors: ["Regional Community Foundation", "United Neighborhood Bank", "Health Access Partners", "Volunteer Alliance"],
    vendors: [
      ["Community Resource Hub", "Community Services"],
      ["Volunteer Connection", "Volunteer Services"],
      ["Mission Market", "Social Enterprise"],
      ["Community Cafe", "Refreshments"],
    ],
    participantTicket: ["Mission Showcase Reception", "Admission to the program showcase and supporter reception.", 2000],
    auctionItems: [
      ["Community Leadership Lunch", "Regional Community Foundation"],
      ["Volunteer Team Experience", "Volunteer Alliance"],
      ["Social Enterprise Gift Set", "Mission Market"],
      ["Impact Story Photo Session", "Community Media Project"],
    ],
    products: [
      ["Mission in Action T-Shirt", "Apparel"],
      ["Community Supporter Tote", "Accessories"],
      ["Impact Report Journal", "Stationery"],
      ["Volunteer Champion Pin", "Collectibles"],
    ],
    hashtags: ["Nonprofit", "MissionInAction", "CommunityImpact"],
    passportPeople: ["Naomi Evans", "Xavier Moore", "Leila Ahmed"],
  }),
  other: profile({
    sponsorLevels: ["Presenting Partner", "Featured Partner", "Supporting Partner", "Community Partner"],
    sponsors: ["Community Partners Group", "Local Business Network", "Civic Support Foundation", "Neighborhood Alliance"],
    vendors: [
      ["Community Welcome Booth", "Guest Services"],
      ["Local Makers Table", "Community Vendor"],
      ["Event Refreshments", "Food Vendor"],
      ["Information Center", "Event Services"],
    ],
    participantTicket: ["Participant Pass", "Participant admission and event access.", 1500],
    auctionItems: [
      ["Community Experience Package", "Community Partners Group"],
      ["Local Dining Collection", "Local Business Network"],
      ["Featured Creator Package", "Local Makers Table"],
      ["VIP Event Experience", "Neighborhood Alliance"],
    ],
    products: [
      ["Official Event T-Shirt", "Apparel"],
      ["Community Event Tote", "Accessories"],
      ["Event Sticker Pack", "Accessories"],
      ["Commemorative Poster", "Collectibles"],
    ],
    hashtags: ["CommunityEvent", "PeopleChoice", "LetsGoVote"],
    passportPeople: ["Robin Ellis", "Cameron Diaz", "Skyler James"],
  }),
  sap_ai_agents_challenge: profile({
    sponsorLevels: ["Innovation Partner", "Challenge Partner", "Technology Partner", "Community Partner"],
    sponsors: ["Northstar Cloud Labs", "Elevate Data Systems", "FutureWorks Network", "Milan Innovation Forum"],
    vendors: [
      ["Innovation Cafe", "Refreshments"],
      ["Partner Demo Lounge", "Technology Showcase"],
      ["Developer Resource Desk", "Technical Resources"],
      ["Milan Creator Market", "Event Merchandise"],
    ],
    participantTicket: ["AI Challenge Conference Pass", "Conference access with partner showcase admission.", 7500],
    auctionItems: [
      ["AI Strategy Workshop", "Northstar Cloud Labs"],
      ["Innovation Leadership Dinner", "Milan Innovation Forum"],
      ["Cloud Architecture Review", "Elevate Data Systems"],
      ["Partner Demo Coaching Session", "FutureWorks Network"],
    ],
    products: [
      ["AI Agents Challenge Hoodie", "Apparel"],
      ["Innovation Notebook", "Stationery"],
      ["Partner Showcase Tote", "Accessories"],
      ["Challenge Commemorative Pin", "Collectibles"],
    ],
    hashtags: ["AIAgents", "EnterpriseAI", "InnovationChallenge"],
    passportPeople: ["Alessandra Moretti", "Luca Bianchi", "Giulia Conti"],
  }),
};

export const getPowerUpProfile = (industryKey = "other") =>
  POWER_UP_PROFILES[industryKey] || POWER_UP_PROFILES.other;
